import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import PasswordUpdateForm from '../../components/auth/PasswordUpdateForm';
import { useAuth } from '../../context/UserContext';
import AuthSidebar from '../../components/auth/AuthSideBar';
import UserDeleteModal from '../../components/auth/UserDeleteForm';
import utils from '../../utils';

function AccessPage() {
    const [activeTab, setActiveTab] = useState(0);
    const { isAuth } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isAuth) {
            navigate('/auth/login', { replace: true });
        }
    }, [isAuth, navigate]);

    const tabs = [
        "Update Password",
        "Account Management"
    ];

    return (
        <main className="container mx-auto px-6 py-4">
            <Helmet>
                <title>Account - {utils.siteName}</title>
                <meta name="robots" content="noindex" />
                <meta name="description" content="Update your password or manage your account." />
            </Helmet>

            <div className="flex flex-col md:flex-row gap-8 lg:gap-12">
                <AuthSidebar />

                <div className="flex-1">
                    <div className="">
                        <div className="">
                            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6">
                                <div>
                                    <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white">
                                        Account
                                    </h1>
                                    <p className="text-gray-500 dark:text-gray-400 mt-1">
                                        Update your current password or delete your account.
                                    </p>
                                </div>
                            </div>

                            <div className="flex justify-center">
                                <div className="border-t border-gray-200 dark:border-border-dark pt-6">
                                    <div className="tabs tabs-boxed justify-center">
                                        {tabs.map((tab, idx) => (
                                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                            <a
                                                key={idx}
                                                className={`tab ${activeTab === idx ? 'tab-active bg-primary text-white rounded-lg' : ''}`}
                                                onClick={() => setActiveTab(idx)}
                                                role="tab"
                                                aria-selected={activeTab === idx}
                                            >
                                                {tab}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="mt-8">
                                {activeTab === 0 && (
                                    <div>
                                        <PasswordUpdateForm />
                                    </div>
                                )}

                                {activeTab === 1 && (
                                    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-md overflow-hidden border border-border-light dark:border-border-dark">
                                        <div className="p-6 md:p-8">
                                            <UserDeleteModal />
                                            <div className="border-l-4 border-error pl-4 py-4">
                                                <h3 className="font-bold text-error text-lg">Danger Zone</h3>
                                                <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                                                    Deleting your account will permanently erase all your data.
                                                    This action cannot be undone.
                                                </p>
                                                <div className="pt-4">
                                                    <button
                                                        className="mt-4 flex items-center space-x-2 bg-error text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-error/90 transition-colors"
                                                        onClick={() => {
                                                            const modal = document.getElementById('user-delete-modal');
                                                            if (modal) modal.checked = true;
                                                        }}
                                                    >
                                                        Delete Account
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default AccessPage;